<div class="p-20 fx-column">
  <span class="title fx-flex-100 mb-10 text-center">{{ "TRADEMARK.COMPARISON_CANDIDATES_TITLE" | translate }}</span>
  <span class="text dark mb-10" [innerHTML]="'TRADEMARK.COMPARISON_CANDIDATES_TEXT' | translate:sourceParams"></span>
  @if (hasMatch) {
    <span class="text dark mb-10">{{ "TRADEMARK.COMPARISON_CANDIDATES_PRESELECTION" | translate }}</span>
  } @else {
    <div class="no-match fx-row align-items-start justify-content-start p-10 mb-10">
      <mat-icon class="orange mr-10" fontSet="material-icons-outlined">error</mat-icon>
      <div class="fx-column">
        <span class="text">{{ "SYNC.CANDIDATES.NO_MATCH" | translate }}</span>
        @if (failureKey) {
          <span class="text orange">{{ failureKey | translate }}</span>
        }
      </div>
    </div>
  }
  <div class="fx-column candidates">
    @for (candidate of candidates; track $index) {
      <div class="candidate fx-row align-items-start justify-content-start p-16 mb-10 clickable"
        [class.selected]="selected === candidate" (click)="select(candidate)">
        <mat-icon class="mr-10" [class.main]="selected === candidate" [class.light]="selected !== candidate"
          fontSet="material-icons-outlined">{{ selected === candidate ? 'radio_button_checked' :
          'radio_button_unchecked' }}</mat-icon>
        <div class="reproduction fx-row align-items-center justify-content-center mr-16">
          @if (candidate.reproductionURI) {
            <img [src]="candidate.reproductionURI" alt="" />
          } @else {
            <span class="text light">-</span>
          }
        </div>
        <div class="fx-column fx-flex">
          <div class="fx-row fx-wrap align-items-center justify-content-start gap-5">
            @if (candidate.name) {
              <span class="text bold">{{ candidate.name }}</span>
            } @else if (candidate.type === 'Figurative') {
              <span class="text light">({{ 'TRADEMARK.FIGURATIVE' | translate }})</span>
            } @else {
              <span class="text light">-</span>
            }
            @if (candidate.incomplete) {
              <span class="chip small orange">{{ 'SYNC.CANDIDATES.INCOMPLETE' | translate }}</span>
            }
            @if (candidate.blankImage) {
              <span class="chip small light">{{ 'SYNC.CANDIDATES.BLANK_IMAGE' | translate }}</span>
            }
          </div>
          <div class="fx-row fx-wrap align-items-start justify-content-start mt-5">
            <div class="fx-flex-50 fx-column pv-5">
              <span class="small light">{{ 'TRADEMARK.IDENTIFIER_NUMBER_SHORT' | translate }}</span>
              <span class="text">{{ candidate.identifierNumber || '-' }}</span>
            </div>
            <div class="fx-flex-50 fx-column pv-5">
              <span class="small light">{{ 'ENTITIES.TERRITORY' | translate }}</span>
              <app-trademark-country [wipoCode]="candidate.countryOfDesignation" displayMode="full"></app-trademark-country>
            </div>
            <div class="fx-flex-50 fx-column pv-5">
              <span class="small light">{{ 'TRADEMARK.APPLICATION_NUMBER' | translate }}</span>
              <span class="text">{{ candidate.applicationNumber || '-' }}</span>
            </div>
            <div class="fx-flex-50 fx-column pv-5">
              <span class="small light">{{ 'TRADEMARK.REGISTRATION_NUMBER' | translate }}</span>
              <span class="text">{{ candidate.registrationNumber || '-' }}</span>
            </div>
            <div class="fx-flex-50 fx-column pv-5">
              <span class="small light">{{ 'TRADEMARK.APPLICATION_DATE' | translate }}</span>
              <span class="text">{{ formatDate(candidate.applicationDate) }}</span>
            </div>
            <div class="fx-flex-50 fx-column pv-5">
              <span class="small light">{{ 'TRADEMARK.STATUS' | translate }}</span>
              @if (candidate.status) {
                <div class="fx-row"><app-trademark-status [status]="candidate.status"></app-trademark-status></div>
              } @else {
                <span class="text light">-</span>
              }
            </div>
            <div class="fx-flex-100 fx-column pv-5">
              <span class="small light">{{ 'TRADEMARK.NICE_CLASSIFICATION_SHORT' | translate }}</span>
              @if (candidate.niceClassification && candidate.niceClassification.length > 0) {
                <div class="fx-row fx-wrap align-items-center justify-content-start">
                  <app-trademark-nice-classification
                    [niceClassification]="classNumbers(candidate)"></app-trademark-nice-classification>
                </div>
              } @else {
                <span class="text light">-</span>
              }
            </div>
          </div>
        </div>
        <div class="checks fx-column ml-16">
          @for (check of checks; track check.key) {
            @switch (checkState(candidate, check.key)) {
              @case ('SAME') {
                <div class="fx-row align-items-center justify-content-start pv-5" [matTooltipClass]="{'uzai-tooltip':true}"
                  [matTooltip]="'SYNC.CANDIDATES.CHECK_SAME' | translate">
                  <mat-icon class="green mr-5" fontSet="material-icons-outlined">check_circle</mat-icon>
                  <span class="text">{{ check.label | translate }}</span>
                </div>
              }
              @case ('DIFFERENT') {
                <div class="fx-row align-items-center justify-content-start pv-5" [matTooltipClass]="{'uzai-tooltip':true}"
                  [matTooltip]="'SYNC.CANDIDATES.CHECK_DIFFERENT' | translate">
                  <mat-icon class="orange mr-5" fontSet="material-icons-outlined">error</mat-icon>
                  <span class="text">{{ check.label | translate }}</span>
                </div>
              }
              @default {
                <div class="fx-row align-items-center justify-content-start pv-5" [matTooltipClass]="{'uzai-tooltip':true}"
                  [matTooltip]="'SYNC.CANDIDATES.CHECK_UNKNOWN' | translate">
                  <mat-icon class="light mr-5" fontSet="material-icons-outlined">remove</mat-icon>
                  <span class="text light">{{ check.label | translate }}</span>
                </div>
              }
            }
          }
        </div>
      </div>
    }
  </div>
  <mat-divider class="fx-flex-100 mv-10"></mat-divider>
  <div class="fx-row align-items-center justify-content-center fx-flex-100">
    <button class="button fx-flex mr-10" (click)="onCancel()">{{ 'ACTIONS.CANCEL' | translate }}</button>
    <button class="main-button fx-flex ml-10" (click)="onConfirm()" [class.disabled]="!selected"
      [disabled]="!selected">{{ 'ACTIONS.CONFIRM' | translate }}</button>
  </div>
</div>
